import { render, staticRenderFns } from "./TagSettings.vue?vue&type=template&id=63515340&"
import script from "./TagSettings.vue?vue&type=script&lang=js&"
export * from "./TagSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports